import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToasterService } from 'src/app/services/toaster/toaster.service';

@Component({
  selector: 'app-forgot-password-modal',
  templateUrl: './forgot-password-modal.component.html',
  styleUrls: ['./forgot-password-modal.component.scss'],
})
export class ForgotPasswordModalComponent implements OnInit {

  forgotFormgroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ForgotPasswordModalComponent>,
    private toaster: ToasterService,
    private auth: AuthService,
  ) {
  }

  ngOnInit(): void {
  }


  async handleSumbit(): Promise<void> {
    try {
      const result = await this.auth.sendPasswordResetLink(this.forgotFormgroup.value.email);
      this.toaster.success(result?.message);
      this.closeDialog();
    } catch (error: any) {
      console.error(error);
      this.toaster.error(error.error?.message ?? 'Failed to send reset link');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
